import MaterialCategoryEdit from '@/components/material/category/edit/MaterialCategoryEdit.vue'
import MaterialCategoryListExpand from '@/components/material/category/listexpand/MaterialCategoryListExpand.vue'
import PeriodicNameList from '@/components/configs/periodicname/list/PeriodicNameList.vue'
import { mapState } from 'vuex'

const defaultFilterValues = {
  displayActive: [1],
  displayActiveNames: 1
};

export default {
  name: 'MaterialCategoryList',
  components: {
    MaterialCategoryEdit,
    MaterialCategoryListExpand,
    PeriodicNameList
  },
  data () {
    return {
      loading: true,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues)
    };
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('material-category.title'), type: 'slot', slotcode: 'customtext', searchFunc: this.getMaterialCategoryFilterTxt },
        { key: 'tooltip', label: this.$t('material-category.tooltip'), type: 'slot', slotcode: 'customtext', searchFunc: this.getMaterialCategoryTooltipTxt },
        { key: 'code', label: this.$t('general.item.code') },
        { key: 'all_subcategories.length', label: this.$t('material-category.subcategory_count') },
        { key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' },
        { key: 'from_date_period_id', label: this.$t('material-category.from_date_period_id'), format: 'formatDatePeriod' },
        { key: 'to_date_period_id', label: this.$t('material-category.to_date_period_id'), format: 'formatDatePeriod' },
        { key: 'order', label: this.$t('general.item.order') }
      ];
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.material.category.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.material.category.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
          { label: this.$t('menu.material.category.restore'), emit: 'restoreItem', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
        ];
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    activePeriodId () {
      if (this.filterValues.displayActiveNames == 1) {
        return this.ZPFormatHelper.getCurrentDatePeriodId();
      }
      return null;
    },
    tableExpandConfig () {
      return { component: 'slot' };
    },
    tableFilterConfig () {
      const filters = { };
      filters.displayActive = { type: 'checkbox', label: this.$t('general.filters.displayOnly'), options: [{ code: 1, value: 1, text: this.$t('general.filters.active') }] };
      filters.displayActiveNames = { type: 'radio', label: this.$t('material.displayActiveNames'), options: this.yesNoOptions };
      return filters;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    filteredItems () {
      if (this.filterValues.displayActive.indexOf(1) > -1) {
        const currentDatePeriodId = (this.config.currentDatePeriod ? this.config.currentDatePeriod.id : 0);
        return this.tableItems.filter(function (el) {
          return (el.to_date_period_id === null || el.to_date_period_id >= currentDatePeriodId);
        });
      }
      return this.tableItems;
    },
    materialCateogryClassId () {
      return this.$store.getters.getDataFromConfigById('model_classes', 'material_categories');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    }
  },
  methods: {
    getTableData () {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('material/category/list', this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
        }
        self.loading = false;
      });
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('material/category/deleted', this.ApiRequest.REQUEST_POST, { code: el.code, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    itemUpdated () {
      this.$emit('saved');
      this.$store.dispatch('loadConfig');
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('material-category.deleteTitle'), this.$t('material-category.deleteMessage', { categoryName: this.BasicHelper.getTranslation(el.name) }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    getMaterialCategoryFilterTxt (text, el) {
      return this.ZPFormatHelper.getConfigValuePeriod('material_categories', 'id', el.id, 'name', true, this.activePeriodId);
    },
    getMaterialCategoryTooltipTxt (text, el) {
      return this.ZPFormatHelper.getConfigValuePeriod('material_categories', 'id', el.id, 'tooltip', true, this.activePeriodId);
    }
  },
  mounted () {
    this.getTableData();
  }
}
